/**
 * 解析 ortho API JSON；非成功时抛带 code/payload 的 Error
 */
export default async function orthoReadJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    const err = new Error(data.message || data.error || `请求失败 ${res.status}`);
    err.code = data.error;
    err.payload = data;
    throw err;
  }
  return data;
}
